module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Les Roberts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Les Roberts")]), _vm._v(" won the initial PWA Best First Private Eye Novel Competition and is the author of the Milan Jacovich mystery series. He is a winner of the Cleveland Arts Prize for Literature and the Sherwood Anderson Literary Award. Roberts lives in Ohio.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OYJsSP/images/9781429984096.jpg?1727382324105",
      "alt": "This image is the cover for the book Strange Death of Father Candy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Strange Death of Father Candy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Vietnam veteran Dominick Candiotti has been long estranged from his family. His late parents were close to the ruling mob clan in Youngstown, his sister was a bad-tempered and dissatisfied nag, and his middle brother was a corruptible police lieutenant. But in 1985, their oldest brother Richard Candiotti---beloved by every Italian Catholic in Youngstown as \"Father Candy\"---dies, and Dominick returns home for the funeral."), _c('br'), _c('br'), _vm._v("Dominick is greatly disturbed by Richard's death, which has been ruled a suicide. Dissatisfied with this answer, he sets out to find the truth, revealing secrets and coming face-to-face with brutality and violence. "), _c('br'), _c('br'), _vm._v("Award-winning author Les Roberts pens a riveting and moving tale about walking the fragile tightrope between love and hatred.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0